import { ReactNode } from "react";

import { Box } from "@mui/material";

interface AccessibleHiddenTextProps {
  children: ReactNode;
}

/**
 * This is used to display text information when visual context clues are there (Accessibility).
 */
export function HiddenText(props: AccessibleHiddenTextProps) {
  return (
    <Box
      component="span"
      sx={{
        position: "absolute !important",
        width: "1px !important",
        height: "1px !important",
        padding: "0 !important",
        margin: "-1px !important",
        overflow: "hidden !important",
        whiteSpace: "nowrap !important",
        border: "0 !important",
      }}
    >
      {props.children}
    </Box>
  );
}
